import type { StateCreator } from "zustand";

export interface HoverTimeSlice {
    timestamp: number | null;
    setTimestamp: (timestamp: number | null) => void;
}

export const createHoverTimeSlice: StateCreator<HoverTimeSlice, [], [], HoverTimeSlice> = (set) => ({
    timestamp: null,
    setTimestamp: (timestamp: number | null) => set({ timestamp }),
});
